import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9fsdrgr4qg: FaireBrandEntity = {
  token: "b_9fsdrgr4qg",
  type: "brand",
  name: "ZaZa Snacks",
  avatarUrl:
    "https://cdn.faire.com/fastly/9da3b0179405757eb6d249ed705b4d2cec8b4a4c5fe20fe930a5a0f9e854f1b5.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a7946c60c9233b90399bd4e03a30f62fbd19dda7bc88b836757a10aab66c225e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9da3b0179405757eb6d249ed705b4d2cec8b4a4c5fe20fe930a5a0f9e854f1b5.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a7946c60c9233b90399bd4e03a30f62fbd19dda7bc88b836757a10aab66c225e.jpeg",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 80,
  rating: 5,
  reviewCount: 6,
  isInsider: true,
  description:
    'ZaZa is a new Brooklyn based company that makes thin and crisp pita chips. Food and Wine magazine declares them "too delicious to be dipped".  We bake in small batches using freshly baked pita bread to ensure the highest quality and a homemade taste. We take pride in being the only pita chip company that uses extra virgin olive oil. Believe us when we say there is no other pita chip like ours on the market. Our company is vegan friendly, preservative-free, and GMO-free. All of our suppliers are top-notch and 3rd party audited. Pass the ZaZa!',
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:45.907Z",
    importedBy: "entity-db-cli",
  },
};
